import { Form, Input, Grid, Select, Field, Button, Icon, Table, Pagination, Tab, Upload, Dialog, Balloon, DatePicker } from "@alifd/next";
import { BefGlobalContext, BefMessageButtonType, BefMessageServiceContext, BefMessageType, BefPageContainerServiceContext, BefPageServiceContext } from "@beflam/bef-core";
import axios from "axios";
import { forwardRef, useContext, useEffect, useRef, useState } from "react";
import { MixIcon } from "../MixIcon";
import { ObjectFile, UploadFile } from "@alifd/next/types/upload/types";
import { Base64 } from 'js-base64';
import { saveAs } from "file-saver";
import { DropdownButton } from "../dropdown-button";


const Tooltip = Balloon.Tooltip;
const DocumentManager = forwardRef((props: any, ref) => {
    const { datas, type, typeId, style, ...otherProps } = props;

    let [dataSource, setDataSource] = useState({
        data: [] as any[], dataSource: [] as any[], currentPage: 1, selectedRowKeys: [], selectRecords: [] as any[], columnWidth: {

            Path: 300,
            Name: 200,
            IsDir: 100,
            Size: 100,
            LastModified: 200,
            ETag: 100


        } as any
    });
    let [visible, setVisible] = useState({ upload: false, uploadImg: false, imgEdit: false });
    const setVisibleEx = (data: any) => {
        visible = data;
        setVisible(data);
    }
    const [uploadValues, setUploadValues] = useState<any>([]);
    const pageService = useContext(BefPageServiceContext);
    const sGlobal = useContext(BefGlobalContext);
    const messageService = useContext(BefMessageServiceContext);
    const pageSize = 10;
    let contextComp: any = {};
    const [dataSource1, setDataSource1] = useState({});
    const [divHeight, setDivHeight] = useState<any>(0);
    const perRef = useRef(null);
    contextComp.setState = (data: any) => {
        setDataSource1(data);
    }
    const fieldRef = useRef(new Field(contextComp));
    const [uploadUrl, SetUploadUrl] = useState("");
    const [header, setHeader] = useState<any>();
    let pathRef = useRef<any>();
    const previewHost = sGlobal?.extend?.KKFileView?.Host;
    const refresh = async () => {
        try {
            sGlobal.showloading = true;
            sGlobal.showLoadingEvent.emit();
            let url = sGlobal.config.host + `/api/document/listitems?type=${type}&typeid=${typeId}&path=${pathRef.current}`;

            const response = await axios.get(url, { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } }
            );
            if (response.data.sucess.toString() === "false") {
                throw JSON.stringify(response.data);
            }
            else {
                let data = [] as any;
                if (response.data.data)
                    data = response.data.data

                dataSource.data = data;
                setDataSourceEx({ ...dataSource, data: data, selectedRowKeys: [], selectRecords: [] });
                onPaginationChange(dataSource.currentPage);
                SetUploadUrl(sGlobal.config.host + `/api/document/upload`)

                setHeader({ 'Authorization': `Bearer ${sGlobal.session.id}` });
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "数据文档列表获取"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const setDataSourceEx = (data: any) => {
        dataSource = data;
        setDataSource(data);
    }
    const onPaginationChange = (current: number, e?: any) => {
        let result = dataSource.data.slice((current - 1) * pageSize, current * pageSize);
        if (result.length > 0) {
            setDataSourceEx({ ...dataSource, dataSource: result, currentPage: current });
        } else {
            if (current !== 1) {
                current = current - 1;
                let _result = dataSource.data.slice((current - 1) * pageSize, current * pageSize);
                setDataSourceEx({ ...dataSource, dataSource: _result, currentPage: current });
            } else {
                setDataSourceEx({ ...dataSource, dataSource: result, currentPage: 1 });
            }
        }

    }
    const actionCellRender = (value: any, index: number, record: any) => {
        // return <>
        //     <Button style={{ marginRight: 12 }} onClick={() => userGroupClick(value, record, { id: 'preview' })}> 预览</Button>
        //     <Button style={{ marginRight: 12 }} onClick={() => userGroupClick(value, record, { id: 'download' })}>下载</Button>
        //     <Button style={{ marginRight: 12 }} onClick={() => userGroupClick(value, record, { id: 'delete' })}> 删除</Button>

        // </>;
        return <>
            <DropdownButton className="ellipsis-btn" style={{ borderRadius: '5px', padding: 0, width: '33px', height: '33px', color: '#262A2A', backgroundColor: '#F6F6F6', border: '1px solid #E8E8E8' }} type="normal" size="medium" popupTriggerType="click" icon="ellipsis" content=""
                itemClick={(args) => userGroupClick(value, record, args)}
                items={[
                    { id: 'preview', children: '预览' },
                    { id: 'download', children: '下载' },
                    { id: 'delete', children: '删除' },

                ]} />
        </>;
    };
    const userGroupClick = (value: any, record: any, args: any) => {
        switch (args.id) {
            case 'download': {
                setDataSourceEx({ ...dataSource, selectedRowKeys: [value], selectRecords: [record] });
                downloadFile();
                break;
            }
            case 'delete': {
                setDataSourceEx({ ...dataSource, selectedRowKeys: [value], selectRecords: [record] });
                deleteData();
                break;
            }
            case 'preview': {
                setDataSourceEx({ ...dataSource, selectedRowKeys: [value], selectRecords: [record] });
                preView();
            }
        }
    }
    const downloadFile = async () => {
        try {
            sGlobal.showloading = true;
            sGlobal.showLoadingEvent.emit();
            let url = sGlobal.config.host + `/${dataSource.selectRecords[0].Path}`;

            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${sGlobal.session.id}`
                }, responseType: 'blob'
            }
            );

            if (!response.data) {
                throw JSON.stringify(response.data);
            }
            else {
                const blob = new Blob([response.data], { type: response.headers["content-type"]?.toString() })
                saveAs(blob, dataSource.selectRecords[0].Name);

            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "文档下载"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const deleteData = async () => {
        try {
            let ids = "";
            if (dataSource.selectedRowKeys == null || dataSource.selectedRowKeys.length === 0 || dataSource.selectedRowKeys.length > 1) throw new Error("请选择一条数据");
            ids = dataSource.selectRecords.map((val) => val.Name).join(",");
            let messageResult = await messageService.showMessage({ mes: `是否确定删除文档：<${ids}>？`, type: BefMessageType.communication, btntype: BefMessageButtonType.YesAndNo });
            if (messageResult === 1) {
                sGlobal.showloading = true;
                sGlobal.showLoadingEvent.emit();
                const response = await axios.post(
                    sGlobal.config.host + `/api/document/delete`,
                    { path: dataSource.selectRecords[0].Path },
                    { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } },

                ).then(response => {
                    if (response.data.success.toString() === 'true') {
                        messageService.showMessage({ mes: `删除<${ids}>成功` });
                        refresh();
                    }
                    else {
                        throw JSON.stringify(response.data);
                    }
                }).catch(error => {
                    throw error;
                });
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "删除文档"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const preView = async () => {
        try {

            if (dataSource.selectedRowKeys == null || dataSource.selectedRowKeys.length === 0 || dataSource.selectedRowKeys.length > 1) throw new Error("请选择一条数据");
            let datas = dataSource.selectRecords.map((val) => val.Id).join(",");
            let _host = sGlobal.config.host ? sGlobal.config.host : window.location.origin;
            window.open(`${previewHost}/onlinePreview?url=${encodeURIComponent(Base64.encode(_host + '/' + dataSource.selectRecords[0].Path))}`);
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "预览文档"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const onSave = async () => {
        try {
            sGlobal.showloading = true;
            sGlobal.showLoadingEvent.emit();
            if (!fieldRef || !fieldRef.current) throw new Error("fieldRef is null");
            let data = fieldRef.current.getValues();
            const response = await axios.put(
                sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets?type=${type}&typeid=${typeId}`,
                { Id: data.Id, Description: data.Description },
                { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } }
            ).then(response => {
                if (response.data.code.toString() === '0') {
                    messageService.showMessage({ mes: `修改<${data.Name}>成功` });
                }
                else {
                    throw JSON.stringify(response.data);
                }
            }).catch(error => {
                throw error;
            });

        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "知识库修改"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    //删除文件加
    const onDelete = async () => {
        try {

            if (!pathRef || !pathRef.current) throw new Error("pathRef is null");
            let ids = pathRef.current;
            let messageResult = await messageService.showMessage({ mes: `是否确定删除路径：<${ids}>？`, type: BefMessageType.communication, btntype: BefMessageButtonType.YesAndNo });
            if (messageResult === 1) {
                sGlobal.showloading = true;
                sGlobal.showLoadingEvent.emit();
                const response = await axios.post(
                    sGlobal.config.host + `/api/document/delete`,
                    { path: pathRef.current },
                    { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } },
                ).then(response => {
                    if (response.data.success.toString() === 'true') {
                        messageService.showMessage({ mes: `删除<${ids}>成功` });
                    } else
                        throw JSON.stringify(response.data.error);
                }).catch(error => {
                    throw error;
                });
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "删除文件夹"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const onUploadChange = (items: any) => {
        let temp = items.map((info: any) => {
            if (info.state == "error") {
                info.errorMsg = info.error?.message;
            }
            return info;
        });
        setUploadValues(temp);
    };
    const beforeUpload = (file: UploadFile) => {
        return new Promise<void>((resolve, reject) => {
            if (file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                resolve();
            } else {
                reject({ message: "不是有效的excel文件" });
            }
        });
    }
    const exFiledata = (file: UploadFile) => {
        return {
            type: type,
            typeId: typeId,
            path: pathRef.current
        };
    }

    const formatRes = (response: any, file: any) => {
        return {
            success: response.success == true,
            message: response.success == true ? "上传成功" : response.error,
        };
    }

    const onOK = () => {
        setVisibleEx({ ...visible, upload: false });
        if (uploadValues && uploadValues.length > 0) {
            refresh();
        }

    }

    useEffect(() => {
        fieldRef.current.reset();
        if (datas) {
            fieldRef.current.setValues(datas);
            pathRef.current = datas.Path;
        }
        refresh();
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                const { width, height } = entry.contentRect;
                //   console.log('Element size changed:', width, height);
                let _height = height;
                if (height > 0) {
                    let diff = _height - 84;
                    if (diff > 0) {
                        if (divHeight !== diff.toString() + 'px')
                            setDivHeight(diff.toString() + 'px');
                    }

                    else
                        setDivHeight('232px');
                }

            }
        });

        if (perRef.current) {
            resizeObserver.observe(perRef.current);
        }

        return () => {
            if (perRef.current) {
                resizeObserver.unobserve(perRef.current);
            }
        };
    }, [datas]);
    return (
        <>
            <div className=" bef-data-manager bef-user bef-user-section padding-24 gap-24-i" style={{ position: 'relative', ...style }}>
                {/* <div className="bef-user-header" style={{ display: 'flex', flexDirection: 'row', gap: 24, height: 'auto' }}>
                    <div className="bef-user-btngroup justify-end">
                   
                    </div>

                </div> */}
                {/* <div className='custom-card padding-16 flex-1 display-flex-col'> */}
                <div className="tab-div" style={{ overflow: 'hidden' }}>
                    <div className="bef-user-header" style={{ display: 'flex', flexDirection: 'row', gap: 24, height: 'auto' }}>
                        {/* <Button style={{ color: '#e41f07', background: 'transparent', border: 'none', padding: '0', fontSize: '14px' }} onClick={() => { pageService.close() }}> <Icon type="arrow-left" /></Button> */}
                        <span className="bef-user-title" style={{ flex: 1 }}>数据文档管理</span>
                        <div className="bef-user-btngroup justify-end">
                            <Button className="custom-btn " type="normal" size="medium" onClick={onDelete}
                                style={{ color: '#ffffff', backgroundColor: 'rgb(255, 56, 60)', borderColor: 'rgb(255, 56, 60)' }} >
                                <MixIcon value="1:trash" size="xs" />删除</Button>
                            <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: 'rgb(12, 156, 252)', borderColor: 'rgb(12, 156, 252)' }} type="normal" size="medium" onClick={() => { setUploadValues([]); setVisibleEx({ ...visible, upload: true }); }}><MixIcon value="1:arrowUpSharp" size="xs" />上传</Button>
                            <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: '#3B5998', borderColor: '#3B5998' }} type="normal" size="medium" onClick={refresh}><MixIcon value="1:reload" size="xs" />刷新</Button>
                        </div>

                    </div>
                    <div style={{ height: 'calc(100% - 36px)', display: 'flex', overflow: 'auto', flexDirection: 'column' }}>
                        <div className="flex-1 margin-top-16 custom-table display-flex-col  " ref={perRef} style={{ overflow: 'hidden', background: '#ffffff' }}>

                            <Table.StickyLock style={{ height: '100%' }} className="bef-user-content bef-data-manager flex-1" fixedHeader size='medium' maxBodyHeight={divHeight} primaryKey="Path" dataSource={dataSource?.dataSource} hasBorder={false}
                                rowSelection={{ selectedRowKeys: dataSource.selectedRowKeys, onChange: (selectedKeys, records) => setDataSourceEx({ ...dataSource, selectedRowKeys: selectedKeys, selectRecords: records }) }}
                                onResizeChange={(dataIndex: string, value: number) => {
                                    let newData = { ...dataSource.columnWidth };
                                    newData[dataIndex] = (newData[dataIndex] ?? 0) + value;
                                    setDataSourceEx({ ...dataSource, columnWidth: newData });
                                }}>
                                <Table.Column asyncResizable title="操作" lock='right' dataIndex="Name" cell={actionCellRender} width={105} />
                                <Table.Column asyncResizable title="名称" dataIndex="Name" width={dataSource.columnWidth.Name} />
                                <Table.Column asyncResizable title="位置" dataIndex="Path" width={dataSource.columnWidth.Path} />

                                <Table.Column asyncResizable title="文件大小" dataIndex="Size" width={dataSource.columnWidth.Size} />
                                <Table.Column asyncResizable title="IsDir" dataIndex="IsDir" width={dataSource.columnWidth.IsDir} />
                                <Table.Column asyncResizable title="ETag" dataIndex="ETag" width={dataSource.columnWidth.ETag} />
                                {/* <Table.Column asyncResizable title="Process" dataIndex="Process" width={dataSource.columnWidth.Process} /> */}
                                <Table.Column asyncResizable title="更新日期" dataIndex="LastModified" width={dataSource.columnWidth.LastModified} cell={(value, index, record) => value ? new Intl.DateTimeFormat('zh-CN').format(new Date(value)) : ''} />

                            </Table.StickyLock>

                            <div className="display-flex justify-end margin-top-8 margin-bottom-8 margin-right-6">
                                <Pagination shape="no-border" pageSize={pageSize} total={dataSource.data.length} current={dataSource.currentPage} onChange={onPaginationChange} />
                            </div>
                        </div>
                    </div>

                </div>





            </div>
            {/* </div> */}
            <Dialog v2 title="文件上传" width={800} visible={visible.upload} footer={[]}
                onClose={onOK}>
                <div className="bef-data-manager">
                    <div style={{ display: 'flex', gap: 8 }}>
                        <Upload
                            action={uploadUrl}
                            onChange={onUploadChange}
                            webkitdirectory
                            value={uploadValues}
                            headers={header}
                            formatter={formatRes}
                            data={exFiledata}
                            beforeUpload={beforeUpload}
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        >
                            <Button className="custom-btn" style={{ marginBottom: '16px', color: '#ffffff', backgroundColor: 'rgb(12, 156, 252)', borderColor: 'rgb(12, 156, 252)' }} type="normal" size="medium" ><MixIcon value="1:arrowUpSharp" size="xs" />上传文件夹</Button>

                        </Upload>
                        <Upload
                            action={uploadUrl}
                            onChange={onUploadChange}
                            value={uploadValues}
                            multiple
                            headers={header}
                            formatter={formatRes}
                            data={exFiledata}
                            beforeUpload={beforeUpload}
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        >
                            <Button className="custom-btn" style={{ marginBottom: '16px', color: '#ffffff', backgroundColor: 'rgb(12, 156, 252)', borderColor: 'rgb(12, 156, 252)' }} type="normal" size="medium" ><MixIcon value="1:arrowUpSharp" size="xs" />上传文件</Button>

                        </Upload>
                    </div>
                    <div style={{ height: 400, overflow: 'auto', }}>
                        <Upload
                            listType="text"
                            value={uploadValues}
                        >
                        </Upload>
                    </div>


                </div>
            </Dialog>

        </>

    );
});
export default DocumentManager;